import FilterBox from "../filter-box";
import FilterBase from "../filter-base";
import { asyncForEach, hide, show } from "../../common";
import { FilterActiveValue } from "../active-filters";
import CheckboxOption from "./checkbox-option";
import FilterParamStats from "../filter-stats";
import { FilterParamItem } from "../filter-param-items";



export default class CheckboxFilter extends FilterBase {

    private options: CheckboxOption[];
    private showMoreText: string;
    private showLessText: string;
    private itemsWrapper: HTMLElement;
    private isHandlingSelectionUpdate: boolean;

    constructor(element: HTMLElement, filterBox: FilterBox) {
        super(element, filterBox);
    }

    init(): void {
        this.showMoreText = this.baseElement.dataset.showMoreText;
        this.showLessText = this.baseElement.dataset.showLessText;
        this.options = [...this.baseElement.querySelectorAll('[data-wrapper-list-id]')]
            .map(e => new CheckboxOption(this.paramId, this.pageId, e as HTMLElement, () => this.onSelectionUpdate(), this.showMoreText, this.showLessText));
        this.itemsWrapper = this.baseElement.querySelector('[data-component-part="items-wrapper"]');
    }

    protected async setValuesInternal(selectedIdsContactenated: string): Promise<void> {
        const selectedIds = selectedIdsContactenated.split(',');
        await asyncForEach(this.options, o => o.selectByIds(selectedIds));
    }

    protected clearValuesInternal(): void {
        this.options.forEach(o => o.clear());
    }

    private onSelectionUpdate(): void {
        if (this.isHandlingSelectionUpdate)
            return;
        this.isHandlingSelectionUpdate = true;

        try {
            this.unselectParentsWithoutSelectedChildren();
            this.updateAttributeAndApplyChanges();
        }
        finally {
            this.isHandlingSelectionUpdate = false;
        }
    }
    
    public unselect(value: string): void {
        for (let index = 0; index < this.options.length; index++) {
            const option = this.options[index];
            if(option.unselectValue(value)){
                break;
            }
        }
        this.onSelectionUpdate();
    }

    protected getSelectedValuesConcat(): string {
        return this.getSelectedValues().map(o => o.listId).join(',');
    }

    private getSelectedValues(): CheckboxOption[] {
        let result: CheckboxOption[] = [];
        this.options.forEach(o => result = result.concat(o.getSelectedValues()));
        return result;
    }

    protected getActiveFilterValues(): FilterActiveValue[] {
        const selectedValues = this.getSelectedValues();
        const activeFilterValues = selectedValues
            .filter(x => !x.isTopLevel || x.children.length === 0)
            .map(e => <FilterActiveValue>{ value: e.listId, displayName: e.name });
        
        return activeFilterValues;
    }

    private unselectParentsWithoutSelectedChildren(): void {
        const selectedValuesWithoutSelectedChildren = this.getSelectedValues()
            .filter(x => x.children && x.children.length > 0 && !x.hasSelectedChildren());
        
        if (selectedValuesWithoutSelectedChildren) {
            selectedValuesWithoutSelectedChildren.forEach(o => o.unselect());
        }
    }

    public setStats(stats: FilterParamStats): void {
        const items = stats.Items;

        if(!items || items.length === 0){
            hide(this.baseElement);
            return;
        }
        show(this.baseElement);

        const itemsToAdd = items
            .filter(i => !this.options.find(o => o.listId === i.ListId.toString()));
        itemsToAdd.forEach(i => this.addOption(i));

        this.options.forEach(o => o.updateItems(items));

        if(itemsToAdd.length !== 0)
            this.sortOptionElements();

        this.updateActiveFilterValues();
    }

    private sortOptionElements() {
        while (this.itemsWrapper.firstChild) {
            this.itemsWrapper.removeChild((this.itemsWrapper.lastChild));
        }

        const sortedOptions = this.options.sort((a,b) => a.sortValue - b.sortValue);
        sortedOptions.forEach(o => this.itemsWrapper.appendChild(o.baseElement));
    }

    private addOption(item: FilterParamItem): void {
        const element = CheckboxOption.createOptionElement(item);
        this.addOptionForElement(element);
    }

    private addOptionForElement(element: HTMLElement){
        this.options.push(new CheckboxOption(this.paramId, this.pageId, element, () => this.onSelectionUpdate(), this.showMoreText, this.showLessText));
    }
}
